// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__XXTfn","checked":"CheckBox_checked__6JRIl","tick":"CheckBox_tick__ecLOR","Disabled":"CheckBox_Disabled__hI8g0"};